import { ApiBase } from '.';
import { FilterRequest, FilterResult, ServiceDataResult } from '../models';

const baseUrl = process.env.REACT_APP_API_BASE_URL;

export class Api extends ApiBase {
    static getFilterValues = (filter: FilterRequest) => Api.get(`${baseUrl}/project?codeEn=${filter.codeEn}&polesWithVoltageType=${filter.polesWithVoltageType}&applicationShortEn=${filter.applicationShortEn}&currentMin=${filter.currentMin ?? ''}&currentMax=${filter.currentMax ?? ''}`) as Promise<ServiceDataResult<FilterResult>>;
}
